import ArticleAltmetric
    from "@/src/components/journal-site/articles/article-sidebar/article-altmetric/article-altmetric";
import ArticleCitationFiles
    from "@/src/components/journal-site/articles/article-sidebar/article-citation-files/article-citation-files";
import ArticleCitedBy from "@/src/components/journal-site/articles/article-sidebar/article-cited-by/article-cited-by";
import ArticleComments from "@/src/components/journal-site/articles/article-sidebar/article-comments/article-comments";
import ArticleCopyrightStatement
    from "@/src/components/journal-site/articles/article-sidebar/article-copyright-statement/article-copyright-statement";
import ArticleCrossmark
    from "@/src/components/journal-site/articles/article-sidebar/article-crossmark/article-crossmark";
import ArticleGetPermissionsLink
    from "@/src/components/journal-site/articles/article-sidebar/article-get-permissions-link/article-get-permissions-link";
import ArticleIndexingSources
    from "@/src/components/journal-site/articles/article-sidebar/article-indexing-sources/article-indexing-sources";
import ArticleMetrics from "@/src/components/journal-site/articles/article-sidebar/article-metrics/article-metrics";
import ArticleRelatedArticles
    from "@/src/components/journal-site/articles/article-sidebar/article-related-articles/article-related-articles";
import ArticleShareButtons from "@/src/components/journal-site/articles/article-share-buttons/article-share-buttons";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import ArticleDownloadBox from "./article-download-box/article-download-box";
import {Box} from "@mui/material";
import {faShareNodes} from "@fortawesome/pro-duotone-svg-icons";
import type ArticleSidebarProps from "@/src/_types/Article/article-sidebar";

const ArticleSidebar = (
    {
        data,
        articleUrl,
        statement,
        eISSN,
        hasPlumx,
        citation,
        hasScoupos
    }: ArticleSidebarProps
) => {
    return (
        <Box>
            <ArticleDownloadBox
                data={{
                    id: data?.id,
                    pdf_file: data?.pdf_file,
                    pdf_file_size: data?.pdf_file_size,
                    feature_audio: data?.feature_audio,
                    feature_video: data?.feature_video,
                    feature_slide: data?.feature_slide,
                    supplementary_material: data?.supplementary_material,
                    has_abstract_xml: data?.has_abstract_xml,
                    opr_pdf: data?.opr_pdf,
                    opr_pdf_size: data?.opr_pdf_size
                }}
                articleUrl={articleUrl}
            />
            <ArticleCitationFiles
                articleUrl={articleUrl}
            />
            {
                data?.indexing_source && data?.indexing_source.length > 0 && (
                    <ArticleIndexingSources
                        indexingSources={data?.indexing_source}
                    />
                )
            }
            {data?.doi &&
                <ArticleCrossmark
                    doi={data.doi}
                />
            }
            <Box>
                <StyledDivider
                    label={"Share on"}
                    icon={faShareNodes}
                />
                <ArticleShareButtons
                    articleUrl={articleUrl}
                    title={data?.title}
                />
            </Box>
            <ArticleComments
                comments={data?.comments || []}
            />
            {
                (data?.doi && (hasScoupos || data?.crossref_link !== '')) &&
                <ArticleCitedBy
                    citation={citation}
                    hasScopus={hasScoupos ?? false}
                    articleUrl={articleUrl}
                />
            }
            {
                (data?.publon_badge || hasPlumx) &&
                <ArticleMetrics
                    publonBadge={data?.publon_badge ?? false}
                    doi={data?.doi || ''}
                    hasPlumx={hasPlumx ?? false}
                />
            }
            {
                (data?.doi && eISSN) &&
                <ArticleGetPermissionsLink
                    doi={data.doi}
                    eISSN={eISSN}
                />
            }
            {
                statement &&
                <ArticleCopyrightStatement
                    statement={statement}
                />
            }
            {
                data?.has_altmetric &&
                <ArticleAltmetric
                    doi={data?.doi || ''}
                />
            }
            <ArticleRelatedArticles
                authors={data?.authors || []}
                articleTitle={data?.title || ''}
            />
        </Box>
    )
}

export default ArticleSidebar;
